module.exports = __webpack_public_path__ + "static/img/brain.png";